import React, {
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import {
  Card,
  Spinner,
  Table,
  Button,
  Modal,
  TextInput,
  Select,
  Pagination,
  FileInput,
  Label,
  Badge,
  Dropdown,
} from "flowbite-react";
import { Store } from "../context/store";
import { useNavigate, useSearchParams } from "react-router-dom";
import apiRequest from "../utils/apiRequest";
import {
  HiCheckCircle,
  HiClock,
  HiCollection,
  HiDotsVertical,
  HiEye,
  HiHome,
  HiOfficeBuilding,
  HiOutlineExclamationCircle,
  HiPencilAlt,
  HiPlus,
  HiSearch,
} from "react-icons/hi";
// import { estates } from "../assets/data/estates";
import { useAllPermissions } from "../utils/usePermission";
import { confirmDialog } from "../components/ConfirmDialog";
import DashboardLayout from "../components/layout/DashboardLayout";

function Projects() {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  let [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  let [propertyData, setProperties] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalPages, setTotalPages] = useState(1);
  const page = parseInt(searchParams.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(page);
  const [openModalOut, setOpenModalOut] = useState(false);
  let [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filtersOpen, setFiltersOpen] = useState(false);
  let [error, setError] = useState("");
  let [errorColor, setErrorColor] = useState("");
  const [propertyDetails, setPropertyDetails] = useState({
    title: "",
    address: "",
    description: "",
    propertyType: "",
    propertySize: "",
    documentType: "",
    status: "",
    location: "",

    featuresString: "",
    landmarksString: "",
    videos: "",

    images: [],
    plans: [],

    propertyUnits: [
      {
        unit: "",
        quantity: 0,
        price: null,
        sittingRoom: "",
        bedrooms: "",
        toilet: "",
        bathroom: "",
        dining: "No",
      },
    ],
  });

  const [propertyDetailsEdit, setPropertyDetailsEdit] = useState({
    id: "",
    title: "",
    address: "",
    description: "",
    propertyType: "",
    propertySize: "",
    documentType: "",
    status: "",
    location: "",
    featuresString: "",
    landmarksString: "",
    videos: "",
    images: [],
    plans: [],
    propertyUnits: [], // new array of unit objects
  });

  let [loading3, setLoading3] = useState(false);

  const { canWriteProperty } = useAllPermissions();

  const handleAuthError = (error) => {
    const unauthorizedErrors = [
      "Access Denied: Invalid or expired token. Please login again",
      "Access Denied: Please log in.",
      "Access Denied: Invalid Token.",
      "Access Denied: Invalid or expired token.",
      "Access Denied: Invalid or Expired Token.",
      "Access Denied: No token provided.",
    ];
    if (unauthorizedErrors.includes(error.message)) {
      setMsg("Session Expired!");
      setOpenModalOut(true);
      localStorage.removeItem("royal-token");
    } else {
      console.log(error);
    }
  };

  const loadProperties = useCallback(
    async (a) => {
      setLoading(true);
      try {
        let url;
        if (a) {
          url = `${baseUrl}/propertiess?search=${a}`;
        } else {
          url = `${baseUrl}/propertiess?page=${page}`;
        }
        const token = localStorage.getItem("royal-token");
        const { data } = await apiRequest(url, "GET", null, token);
        setProperties(data.properties);
        setTotalPages(data.totalPages);
      } catch (error) {
        handleAuthError(error);
      } finally {
        setLoading(false);
      }
    },
    [page, baseUrl],
  );

  const addUnit = () => {
    setPropertyDetails((prev) => ({
      ...prev,
      propertyUnits: [
        ...prev.propertyUnits,
        {
          unit: "",
          quantity: 0,
          price: null,
          sittingRoom: "",
          bedrooms: "",
          toilet: "",
          bathroom: "",
          dining: "No",
        },
      ],
    }));
  };

  const removeUnit = (index) => {
    setPropertyDetails((prev) => ({
      ...prev,
      propertyUnits: prev.propertyUnits.filter((_, i) => i !== index),
    }));
  };

  const handleUnitChange = (index, field, value) => {
    setPropertyDetails((prev) => {
      const updatedUnits = [...prev.propertyUnits];
      updatedUnits[index] = {
        ...updatedUnits[index],
        [field]: value,
      };
      return { ...prev, propertyUnits: updatedUnits };
    });
  };

  const addEditUnit = () => {
    setPropertyDetailsEdit((prev) => ({
      ...prev,
      propertyUnits: [
        ...prev.propertyUnits,
        {
          unit: "",
          quantity: 0,
          price: null,
          sittingRoom: "",
          bedrooms: "",
          toilet: "",
          bathroom: "",
          dining: "No",
          propertySize: "",
        },
      ],
    }));
  };

  const removeEditUnit = (index) => {
    setPropertyDetailsEdit((prev) => ({
      ...prev,
      propertyUnits: prev.propertyUnits.filter((_, i) => i !== index),
    }));
  };

  const handleEditUnitChange = (index, field, value) => {
    setPropertyDetailsEdit((prev) => {
      const updatedUnits = [...prev.propertyUnits];
      updatedUnits[index] = {
        ...updatedUnits[index],
        [field]: value,
      };
      return { ...prev, propertyUnits: updatedUnits };
    });
  };

  useEffect(() => {
    Promise.all([loadProperties()])
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [loadProperties]);

  const onPageChange = (page) => {
    setSearchParams({ page: page });
    setCurrentPage(page);
  };

  function onCloseModal() {
    setOpenModal(false);
    setError("");
  }

  function onCloseModalEdit() {
    setOpenModalEdit(false);
    setError("");
    setPropertyDetailsEdit({
      title: "",
      price: null,
      featuresString: "",
      videos: "",
      description: "",
      quantity: null,
      propertyType: "",
      propertySize: "",
      sittingRoom: null,
      bedrooms: null,
      toilet: null,
      bathroom: null,
      documentType: "",
      status: "",
      landmarksString: "",
      address: "",
      dining: "",
      location: "",
      images: [],
      plans: [],
    });
  }

  const searchProperties = async (a) => {
    if (!a) return;
    await loadProperties(a);
    setSearch("");
    setLoading(false);
  };

  const resetSearchProperties = async () => {
    await loadProperties();
    setSearch("");
    setLoading(false);
  };

  const handleChange = (event) => {
    const { name, value, files } = event.target;

    if (files) {
      const selectedFiles = Array.from(files).slice(0, 4);
      setPropertyDetails((prev) => ({
        ...prev,
        [name]: selectedFiles,
      }));
    } else {
      setPropertyDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChangeEdit = (event) => {
    const { name, value, files } = event.target;

    if (files) {
      // Handle multiple files upload for images or plans
      const selectedFiles = Array.from(files).slice(0, 4);

      setPropertyDetailsEdit((prev) => ({
        ...prev,
        [name]: selectedFiles,
      }));
    } else {
      setPropertyDetailsEdit((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const createProperty = async () => {
    if (!propertyDetails.title || !propertyDetails.address) {
      setErrorColor("red");
      setError("Please fill all required fields.");
      return;
    }

    if (!propertyDetails.propertyUnits.length) {
      setErrorColor("red");
      setError("At least one property unit is required.");
      return;
    }

    await confirmDialog("Are you sure you want to add a new property?", {
      title: "Add Property",
      confirmText: "Yes, add property",
      color: "success",
      loadingText: "Adding...",
      onConfirm: async () => {
        setLoading3(true);

        try {
          const formData = new FormData();

          // Root fields
          [
            "title",
            "address",
            "description",
            "propertyType",
            "propertySize",
            "documentType",
            "status",
            // "location",
            "featuresString",
            "landmarksString",
            "videos",
          ].forEach((key) => {
            if (propertyDetails[key] !== undefined) {
              formData.append(key, propertyDetails[key]);
            }
          });

          // Units
          formData.append(
            "propertyUnits",
            JSON.stringify(propertyDetails.propertyUnits),
          );

          // Images
          propertyDetails.images.forEach((img) =>
            formData.append("images", img),
          );
          propertyDetails.plans.forEach((plan) =>
            formData.append("plans", plan),
          );

          const token = localStorage.getItem("royal-token");
          await apiRequest(`${baseUrl}/property`, "POST", formData, token);

          setErrorColor("green");
          setError("Property successfully added.");
          onCloseModal();
          loadProperties();

          setPropertyDetails({
            title: "",
            address: "",
            description: "",
            propertyType: "",
            propertySize: "",
            documentType: "",
            status: "",
            location: "",
            featuresString: "",
            landmarksString: "",
            videos: "",
            images: [],
            plans: [],
            propertyUnits: [],
          });
        } catch (error) {
          handleAuthError(error);
        } finally {
          setLoading3(false);
        }
      },
    });
  };

  const updateProperty = async () => {
    if (!propertyDetailsEdit.title || !propertyDetailsEdit.address) {
      setErrorColor("red");
      setError("Please fill all required fields.");
      return;
    }

    await confirmDialog("Are you sure you want to update this property?", {
      title: "Update Property",
      confirmText: "Yes, update",
      color: "warning",
      loadingText: "Updating...",
      onConfirm: async () => {
        setLoading3(true);

        try {
          const formData = new FormData();

          [
            "title",
            "address",
            "description",
            "propertyType",
            "propertySize",
            "documentType",
            "status",
            "location",
            "featuresString",
            "landmarksString",
            "videos",
          ].forEach((key) => {
            if (propertyDetailsEdit[key] !== undefined) {
              formData.append(key, propertyDetailsEdit[key]);
            }
          });

          formData.append(
            "propertyUnits",
            JSON.stringify(propertyDetailsEdit.propertyUnits),
          );

          propertyDetailsEdit.images.forEach((img) =>
            formData.append("images", img),
          );
          propertyDetailsEdit.plans.forEach((plan) =>
            formData.append("plans", plan),
          );

          const token = localStorage.getItem("royal-token");
          await apiRequest(
            `${baseUrl}/property/${propertyDetailsEdit.id}`,
            "PUT",
            formData,
            token,
          );

          setErrorColor("green");
          setError("Property successfully updated.");
          onCloseModalEdit();
          loadProperties();
        } catch (error) {
          handleAuthError(error);
        } finally {
          setLoading3(false);
        }
      },
    });
  };

  let logOut = () => {
    navigate("/");
  };

  const edit = (e) => {
    setOpenModalEdit(true);
    setPropertyDetailsEdit({
      id: e.id,
      title: e.title,
      address: e.address,
      description: e.description || "",
      propertyType: e.propertyType || "",
      propertySize: e.propertySize || "",
      documentType: e.documentType || "",
      status: e.status || "",
      // location: e.location || "",
      featuresString: e.features?.join(", ") || "",
      landmarksString: e.landmarks?.join(", ") || "",
      videos: e.videos || "",
      images: e.images || [],
      plans: e.plans || [],
      propertyUnits: e.propertyUnits || [], // load existing units
    });
  };

  const analytics = useMemo(() => {
    const visibleProperties = propertyData?.length || 0;
    const approvedProperties =
      propertyData?.filter((property) => property.approved).length || 0;
    const pendingProperties =
      propertyData?.filter((property) => property.approved === false).length ||
      0;
    const totalUnits =
      propertyData?.reduce(
        (sum, property) => sum + (property.propertyUnits?.length || 0),
        0,
      ) || 0;

    return {
      visibleProperties,
      approvedProperties,
      pendingProperties,
      totalUnits,
    };
  }, [propertyData]);

  const AnalyticsCard = ({ title, value, colorClass, icon: Icon }) => (
    <Card className={`shadow-lg p-2 dark:bg-gray-800 border-l-4 ${colorClass}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase">
            {title}
          </p>
          <h2 className="text-2xl font-extrabold text-gray-900 dark:text-white mt-1">
            {value}
          </h2>
        </div>
        <Icon className="w-8 h-8 opacity-60" />
      </div>
    </Card>
  );

  return (
    <>
      <title>Properties</title>
      <meta
        name="description"
        content="Project Page to the Royalmines Property Office"
      />

      <DashboardLayout active="projects" contentClassName="lg:p-8">
        <h5 className="text-3xl font-extrabold text-gray-900 dark:text-white mb-6 flex items-center">
          <HiOfficeBuilding className="w-8 h-8 mr-3 text-blue-600" />
          Property Management
        </h5>

        <hr className="my-6 border-gray-200 dark:border-gray-700" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <AnalyticsCard
            title="Visible Properties"
            value={analytics.visibleProperties}
            colorClass="text-blue-500 border-blue-500"
            icon={HiHome}
          />
          <AnalyticsCard
            title="Approved Properties"
            value={analytics.approvedProperties}
            colorClass="text-green-500 border-green-500"
            icon={HiCheckCircle}
          />
          <AnalyticsCard
            title="Pending Approval"
            value={analytics.pendingProperties}
            colorClass="text-amber-500 border-amber-500"
            icon={HiClock}
          />
          <AnalyticsCard
            title="Visible Units"
            value={analytics.totalUnits}
            colorClass="text-cyan-500 border-cyan-500"
            icon={HiCollection}
          />
        </div>

        <div className="mb-6">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <Button
              color="light"
              onClick={() => setFiltersOpen((prev) => !prev)}
              className="w-full sm:w-auto"
            >
              {filtersOpen ? "Hide Filters" : "Show Filters"}
            </Button>

            <Button
              color="success"
              onClick={() => setOpenModal(true)}
              disabled={!canWriteProperty}
              className="w-full sm:w-auto"
            >
              <HiPlus className="w-5 h-5 mr-2" />
              Add Property
            </Button>
          </div>

          {filtersOpen && (
            <div className="mt-4 bg-white dark:bg-gray-800/60 border border-gray-200 dark:border-gray-700 rounded-xl p-4 sm:p-5 shadow-sm">
              <div className="flex flex-col gap-1">
                <h6 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Filters
                </h6>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  Search property records by name and reset the listing when you
                  are done.
                </p>
              </div>

              <div className="mt-5 grid grid-cols-1 lg:grid-cols-6 gap-4">
                <div className="lg:col-span-3">
                  <label
                    htmlFor="property-search"
                    className="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1"
                  >
                    Property Name
                  </label>
                  <TextInput
                    id="property-search"
                    type="text"
                    placeholder="Search by property name..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <div className="flex flex-col sm:flex-row lg:col-span-3 gap-2 lg:items-end">
                  <Button
                    color="dark"
                    onClick={() => searchProperties(search)}
                    disabled={loading || !search}
                    className="w-full sm:w-auto"
                  >
                    <HiSearch className="w-5 h-5 mr-2" />
                    Search
                  </Button>
                  <Button
                    color="light"
                    onClick={() => resetSearchProperties()}
                    disabled={loading}
                    className="w-full sm:w-auto"
                  >
                    Reset
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>

        <Card className="shadow-2xl dark:bg-gray-800 overflow-x-auto min-h-[400px]">
          {loading ? (
            <div className="flex justify-center items-center min-h-[320px]">
              <Spinner
                style={{ color: "#0078e7" }}
                aria-label="Loading properties"
                size="xl"
              />
            </div>
          ) : propertyData.length === 0 ? (
            <div className="flex min-h-[320px] flex-col items-center justify-center text-center">
              <HiHome className="w-12 h-12 text-gray-300 dark:text-gray-600 mb-3" />
              <h6 className="text-lg font-semibold text-gray-900 dark:text-white">
                No properties found
              </h6>
              <p className="mt-1 max-w-md text-sm text-gray-500 dark:text-gray-400">
                Add a property or adjust your search filters to populate this
                table.
              </p>
            </div>
          ) : (
            <div className="overflow-x-auto overflow-y-auto max-h-[58vh] scrollbar-always-visible">
              <Table hoverable striped>
                <Table.Head className="sticky top-0 z-10">
                  <Table.HeadCell>Property</Table.HeadCell>
                  <Table.HeadCell>Address</Table.HeadCell>
                  <Table.HeadCell>Units</Table.HeadCell>
                  <Table.HeadCell>Status</Table.HeadCell>
                  <Table.HeadCell>Approval</Table.HeadCell>
                  <Table.HeadCell>
                    <span className="sr-only">Actions</span>
                  </Table.HeadCell>
                </Table.Head>
                <Table.Body className="divide-y">
                  {propertyData?.map((property) => (
                    <Table.Row
                      key={property.id}
                      className="bg-white dark:border-gray-700 dark:bg-gray-800"
                    >
                      <Table.Cell className="whitespace-nowrap font-semibold text-gray-900 dark:text-white">
                        {property.title || "Untitled Property"}
                      </Table.Cell>
                      <Table.Cell className="min-w-[260px] text-gray-600 dark:text-gray-300">
                        {property.address || "N/A"}
                      </Table.Cell>
                      <Table.Cell>
                        {property.propertyUnits?.length || 0}
                      </Table.Cell>
                      <Table.Cell>
                        <Badge color="info">
                          {property.status || "Now Selling"}
                        </Badge>
                      </Table.Cell>
                      <Table.Cell>
                        <Badge
                          color={property.approved ? "success" : "warning"}
                        >
                          {property.approved ? "Approved" : "Pending"}
                        </Badge>
                      </Table.Cell>
                      <Table.Cell>
                        <Dropdown
                          label={<HiDotsVertical className="w-5 h-5" />}
                          inline
                          arrowIcon={false}
                        >
                          <Dropdown.Item
                            icon={HiEye}
                            onClick={() => navigate(`/property/${property.id}`)}
                          >
                            View Property
                          </Dropdown.Item>
                          <Dropdown.Item
                            icon={HiPencilAlt}
                            onClick={() => edit(property)}
                            disabled={!canWriteProperty}
                          >
                            Edit Property
                          </Dropdown.Item>
                        </Dropdown>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Card>

        {propertyData?.length > 0 && (
          <div className="flex overflow-x-auto sm:justify-center mt-6 mb-2">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
              showIcons
              previousLabel=""
              nextLabel=""
            />
          </div>
        )}
      </DashboardLayout>

      {/* modal for new Project */}
      <Modal
        show={openModal}
        size="5xl"
        onClose={onCloseModal}
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          // The backdrop needs a high z-index too
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header>
          <div className="w-full flex justify-center pt-4">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white text-center">
              Add New Property
            </h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="space-y-6 max-h-[60vh] overflow-y-auto">
            {/* Error */}
            <div className="flex justify-center">
              <small style={{ color: errorColor, textAlign: "center" }}>
                {error}
              </small>
            </div>

            {/* ================= BASIC INFO ================= */}
            <section className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                Basic Information
              </h4>

              <div className="grid grid-cols-1 gap-4">
                <div>
                  <Label value="Property Name" />
                  <TextInput
                    name="title"
                    value={propertyDetails.title}
                    onChange={handleChange}
                  />
                </div>

                {/* <div>
                  <Label value="Property Type" />
                  <TextInput
                    name="propertyType"
                    placeholder="Duplex, Bungalow, Apartment"
                    value={propertyDetails.propertyType}
                    onChange={handleChange}
                  />
                </div> */}
              </div>
            </section>

            {/* ================= LOCATION ================= */}
            <section className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                Location & Status
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <Label value="Full Address" />
                  <TextInput
                    name="address"
                    value={propertyDetails.address}
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <Label value="Property Title" />
                  <Select
                    name="documentType"
                    value={propertyDetails.documentType}
                    onChange={handleChange}
                  >
                    <option value="">Select document type</option>
                    <option value="Certificate of Occupancy (C of O)">
                      Certificate of Occupancy (C of O)
                    </option>
                    <option value="Right of Occupancy (R of O)">
                      Right of Occupancy (R of O)
                    </option>
                    <option value="Gazette">Gazette</option>
                    <option value="Deed of Assignment">
                      Deed of Assignment
                    </option>
                  </Select>
                </div>

                {/* <div>
                  <Label value="Location Area" />
                  <Select
                    name="location"
                    value={propertyDetails.location}
                    onChange={handleChange}
                  >
                    <option value="">Select Location</option>
                    {estates?.map((estate, i) => (
                      <option
                        key={i}
                        value={`${estate.name} - ${estate.address}`}
                      >
                        {estate.name} — {estate.address}
                      </option>
                    ))}
                  </Select>
                </div> */}

                <div>
                  <Label value="Property Status" />
                  <TextInput
                    name="status"
                    value={propertyDetails.status}
                    onChange={handleChange}
                  />
                </div>

                {/* <div>
                  <Label value="Property Size" />
                  <TextInput
                    name="propertySize"
                    placeholder="e.g. 400sqm"
                    value={propertyDetails.propertySize}
                    onChange={handleChange}
                  />
                </div> */}
              </div>
            </section>

            {/* ================= PROPERTY UNITS ================= */}
            <section className="space-y-4">
              <div className="flex justify-between items-center">
                <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                  Property Units
                </h4>

                <Button size="sm" onClick={addUnit}>
                  + Add Unit
                </Button>
              </div>

              {propertyDetails?.propertyUnits?.map((unit, index) => (
                <div
                  key={index}
                  className="border rounded-lg p-4 space-y-4 bg-gray-50 dark:bg-gray-800"
                >
                  <div className="flex justify-between items-center">
                    <h5 className="font-medium">Unit {index + 1}</h5>
                    <Button
                      size="xs"
                      color="failure"
                      onClick={() => removeUnit(index)}
                    >
                      Remove
                    </Button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                      <Label value="Building Type" />
                      <TextInput
                        placeholder="1 Bedroom Apartment"
                        value={unit.unit}
                        onChange={(e) =>
                          handleUnitChange(index, "unit", e.target.value)
                        }
                      />
                    </div>

                    <div>
                      <Label value="Number of Units" />
                      <TextInput
                        type="number"
                        step="0.01"
                        min={0}
                        value={unit.quantity}
                        onChange={(e) =>
                          handleUnitChange(index, "quantity", e.target.value)
                        }
                      />
                    </div>

                    <div>
                      <Label value="Price (₦)" />
                      <TextInput
                        type="number"
                        step="0.01"
                        value={unit.price}
                        onChange={(e) =>
                          handleUnitChange(index, "price", e.target.value)
                        }
                      />
                    </div>

                    <div>
                      <Label value="Bedrooms" />
                      <TextInput
                        value={unit.bedrooms}
                        onChange={(e) =>
                          handleUnitChange(index, "bedrooms", e.target.value)
                        }
                      />
                    </div>

                    <div>
                      <Label value="Sitting Rooms" />
                      <TextInput
                        value={unit.sittingRoom}
                        onChange={(e) =>
                          handleUnitChange(index, "sittingRoom", e.target.value)
                        }
                      />
                    </div>

                    <div>
                      <Label value="Bathrooms" />
                      <TextInput
                        value={unit.bathroom}
                        onChange={(e) =>
                          handleUnitChange(index, "bathroom", e.target.value)
                        }
                      />
                    </div>

                    <div>
                      <Label value="Toilets" />
                      <TextInput
                        value={unit.toilet}
                        onChange={(e) =>
                          handleUnitChange(index, "toilet", e.target.value)
                        }
                      />
                    </div>

                    <div>
                      <Label value="Dining Area?" />
                      <Select
                        value={unit.dining}
                        onChange={(e) =>
                          handleUnitChange(index, "dining", e.target.value)
                        }
                      >
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                      </Select>
                    </div>
                  </div>
                </div>
              ))}
            </section>

            {/* ================= FEATURES & MEDIA ================= */}
            <section className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                Features & Media
              </h4>

              <TextInput
                placeholder="Features (comma separated)"
                name="featuresString"
                value={propertyDetails.featuresString}
                onChange={handleChange}
              />

              <TextInput
                placeholder="Landmarks (comma separated)"
                name="landmarksString"
                value={propertyDetails.landmarksString}
                onChange={handleChange}
              />

              <TextInput
                placeholder="YouTube video URL"
                name="videos"
                value={propertyDetails.videos}
                onChange={handleChange}
              />
            </section>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="w-full flex justify-center pt-4">
            <Button
              disabled={loading3}
              onClick={() => createProperty()}
              color="failure"
            >
              {/* Using a different color for the primary action button */}
              {loading3 ? "Creating Property..." : "Add Property"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal for edit Project */}
      <Modal
        show={openModalEdit}
        size="5xl"
        onClose={onCloseModalEdit}
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          // The backdrop needs a high z-index too
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header>
          <div className="w-full flex justify-center pt-4">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white text-center">
              Edit Property Details
            </h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="space-y-6 max-h-[60vh] overflow-auto">
            {/* Error message */}
            <div className="flex justify-center">
              <small
                style={{
                  color: errorColor,
                  textAlign: "center",
                }}
              >
                {error}
              </small>
            </div>

            {/* --- Basic Information Section --- */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                Basic Information
              </h4>
              <div className="grid grid-cols-1">
                {/* Property Title */}
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="title" value="Property Title" />
                  </div>
                  <TextInput
                    id="title"
                    placeholder="e.g., Luxurious Family Villa"
                    name="title"
                    value={propertyDetailsEdit.title}
                    onChange={handleChangeEdit}
                  />
                </div>

                {/* Price */}
                {/* <div>
                  <div className="mb-2 block">
                    <Label htmlFor="address" value="Address" />
                  </div>
                  <TextInput
                    id="address"
                    placeholder="Address"
                    name="address"
                    value={propertyDetailsEdit.address}
                    onChange={handleChangeEdit}
                  />
                </div> */}
              </div>
            </div>

            {/* --- Location and Quantity Section --- */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                Location & Availability
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Address */}
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="address" value="Full Address" />
                  </div>
                  <TextInput
                    id="address"
                    placeholder="Street address, city, state"
                    name="address"
                    value={propertyDetailsEdit.address}
                    onChange={handleChangeEdit}
                    type="text"
                  />
                </div>

                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="documentType" value="Document Type" />
                  </div>
                  <Select
                    id="documentType"
                    name="documentType"
                    value={propertyDetailsEdit.documentType}
                    onChange={handleChangeEdit}
                  >
                    <option value="">Select document type</option>
                    <option value="Certificate of Occupancy (C of O)">
                      Certificate of Occupancy (C of O)
                    </option>
                    <option value="Right of Occupancy (R of O)">
                      Right of Occupancy (R of O)
                    </option>
                    <option value="Gazette">Gazette</option>
                    <option value="Deed of Assignment">
                      Deed of Assignment
                    </option>
                  </Select>
                </div>

                {/* Location Select */}
                {/* <div>
                  <div className="mb-2 block">
                    <Label htmlFor="location" value="Select Location Area" />
                  </div>
                  <Select
                    id="location"
                    name="location"
                    value={propertyDetailsEdit.location}
                    onChange={handleChangeEdit}
                    style={{ textTransform: "capitalize" }}
                  >
                    <option value="">Select Location</option>
                    {estates?.map((estate, index) => {
                      const value = `${estate.name} - ${estate.address}`;
                      return (
                        <option key={index} value={value}>
                          {estate.name} — {estate.address}
                        </option>
                      );
                    })}
                  </Select>
                </div> */}

                {/* Quantity */}
                {/* <div>
                  <div className="mb-2 block">
                    <Label htmlFor="quantity" value="Available Quantity" />
                  </div>
                  <TextInput
                    id="quantity"
                    placeholder="Number of units available"
                    type="number"
                            step="0.01"
                    name="quantity"
                    value={propertyDetailsEdit.quantity}
                    onChange={handleChangeEdit}
                    min={1}
                  />
                </div> */}

                {/* Status */}
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="status" value="Property Status" />
                  </div>
                  <TextInput
                    id="status"
                    placeholder="e.g., Now Selling, Sold Out, Under Construction"
                    name="status"
                    value={propertyDetailsEdit.status}
                    onChange={handleChangeEdit}
                    type="text"
                  />
                </div>
              </div>
            </div>

            {/* Property Units Section */}
            <div>
              <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                Property Units
              </h4>

              {propertyDetailsEdit?.propertyUnits?.map((unit, index) => (
                <div
                  key={index}
                  className="border p-4 rounded mb-4 space-y-4 bg-white dark:bg-gray-800"
                >
                  <div className="flex justify-between items-center mb-2">
                    <h5 className="font-semibold">Unit {index + 1}</h5>
                    <button
                      type="button"
                      onClick={() => removeEditUnit(index)}
                      className="text-red-600 hover:underline"
                    >
                      Remove
                    </button>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {/* Unit Name */}
                    <div>
                      <Label value="Building Type" />
                      <TextInput
                        placeholder="e.g., 1 Bedroom Flat"
                        value={unit.unit}
                        onChange={(e) =>
                          handleEditUnitChange(index, "unit", e.target.value)
                        }
                      />
                    </div>

                    {/* Quantity */}
                    <div>
                      <Label value="Number of Units" />
                      <TextInput
                        type="number"
                        step="0.01"
                        min={0}
                        placeholder="Quantity"
                        value={unit.quantity}
                        onChange={(e) =>
                          handleEditUnitChange(
                            index,
                            "quantity",
                            Number(e.target.value),
                          )
                        }
                      />
                    </div>

                    {/* Price */}
                    <div>
                      <Label value="Unit Price (₦)" />
                      <TextInput
                        type="number"
                        step="0.01"
                        placeholder="Price"
                        value={unit.price || ""}
                        onChange={(e) =>
                          handleEditUnitChange(
                            index,
                            "price",
                            e.target.value ? Number(e.target.value) : null,
                          )
                        }
                      />
                    </div>

                    {/* Sitting Room */}
                    <div>
                      <Label value="Sitting Room" />
                      <TextInput
                        placeholder="e.g., 1"
                        value={unit.sittingRoom}
                        onChange={(e) =>
                          handleEditUnitChange(
                            index,
                            "sittingRoom",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    {/* Bedrooms */}
                    <div>
                      <Label value="Bedrooms" />
                      <TextInput
                        placeholder="e.g., 3"
                        value={unit.bedrooms}
                        onChange={(e) =>
                          handleEditUnitChange(
                            index,
                            "bedrooms",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    {/* Toilet */}
                    <div>
                      <Label value="Toilets" />
                      <TextInput
                        placeholder="e.g., 2"
                        value={unit.toilet}
                        onChange={(e) =>
                          handleEditUnitChange(index, "toilet", e.target.value)
                        }
                      />
                    </div>

                    {/* Bathroom */}
                    <div>
                      <Label value="Bathrooms" />
                      <TextInput
                        placeholder="e.g., 2"
                        value={unit.bathroom}
                        onChange={(e) =>
                          handleEditUnitChange(
                            index,
                            "bathroom",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    {/* Dining */}
                    <div>
                      <Label value="Dining Area" />
                      <Select
                        value={unit.dining}
                        onChange={(e) =>
                          handleEditUnitChange(index, "dining", e.target.value)
                        }
                      >
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                      </Select>
                    </div>

                    {/* Property Size */}
                    <div>
                      <Label value="Property Size (sqm)" />
                      <TextInput
                        placeholder="e.g., 250 sqm"
                        value={unit.propertySize || ""}
                        onChange={(e) =>
                          handleEditUnitChange(
                            index,
                            "propertySize",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}

              <button
                type="button"
                onClick={addEditUnit}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Add Unit
              </button>
            </div>

            {/* --- Features and Media Section --- */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                Features and Media
              </h4>
              {/* Features String */}
              <div>
                <div className="mb-2 block">
                  <Label
                    htmlFor="featuresString"
                    value="Features (Comma-separated list)"
                  />
                </div>
                <TextInput
                  id="featuresString"
                  type="text"
                  placeholder="e.g., Security, Water Treatment, Good Road Network"
                  name="featuresString"
                  value={propertyDetailsEdit.featuresString}
                  onChange={handleChangeEdit}
                />
              </div>

              {/* Landmarks String */}
              <div>
                <div className="mb-2 block">
                  <Label
                    htmlFor="landmarksString"
                    value="Nearby Landmarks (Comma-separated list)"
                  />
                </div>
                <TextInput
                  id="landmarksString"
                  placeholder="e.g., Airport, Major Market, School"
                  name="landmarksString"
                  value={propertyDetailsEdit.landmarksString}
                  onChange={handleChangeEdit}
                  type="text"
                />
              </div>

              {/* Youtube Video URL */}
              <div>
                <div className="mb-2 block">
                  <Label
                    htmlFor="videos"
                    value="YouTube Video URL (For property tour)"
                  />
                </div>
                <TextInput
                  id="videos"
                  type="text"
                  placeholder="Paste the full YouTube URL here"
                  name="videos"
                  value={propertyDetailsEdit.videos}
                  onChange={handleChangeEdit}
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Finished Building Images Upload */}
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="multiple-file-upload">
                      Finished Building Images (Max 4)
                    </Label>
                  </div>
                  <FileInput
                    id="multiple-file-upload"
                    name="images"
                    onChange={handleChangeEdit}
                    multiple
                    max={4}
                  />
                  {propertyDetailsEdit.images.length > 0 && (
                    <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                      Selected Images: **{propertyDetailsEdit.images.length}**
                      (max 4)
                    </p>
                  )}
                </div>

                {/* Plans Images Upload */}
                {/* <div>
                  <div className="mb-2 block">
                    <Label htmlFor="multiple-file-upload2">
                      Plans/Floor Plans Images (Max 4)
                    </Label>
                  </div>
                  <FileInput
                    id="multiple-file-upload2"
                    name="plans"
                    onChange={handleChangeEdit}
                    multiple
                    max={4}
                  />
                  {propertyDetailsEdit.plans.length > 0 && (
                    <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                      Selected Images: **{propertyDetailsEdit.plans.length}**
                      (max 4)
                    </p>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-full flex justify-center pt-4">
            <Button
              disabled={loading3}
              onClick={() => updateProperty(propertyDetailsEdit?.id)}
              color="success" // A different color for emphasis
            >
              {loading3 ? "Saving Changes..." : "Update Property"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal for logout */}
      <Modal
        show={openModalOut}
        size="md"
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          // The backdrop needs a high z-index too
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              {msg}
            </h3>
            <div className="flex justify-center gap-4">
              <Button color="failure" onClick={() => logOut()}>
                {"OK"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Projects;
